import React from "react"
import { InlineWidget } from "react-calendly"
import Image from "next/image"
import classes from "./bookingModal.module.scss"
import Modal from "react-modal"

const customStyles = {
  content: {
    position: "relative !important",
    width: "100%",
    height: "100%",
    display: "flex",
    padding: "0px",
    overflow: "auto",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: "100",
  },
  overlay: {
    zIndex: "1000",
  },
}

const SalesForceBookingModal = props => {
  const { modalDescription, contactName, calendlyLink, title, headshotUrl } =
    props.bookMeetingData

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onRequestClose={props.closeModal}
      style={customStyles}
      contentLabel="Example Modal"
      className={classes.container}
    >
      <div className={classes.main}>
        <div className={classes.ModalHeader}>
          <div className={classes.close}>
            <Image
              style={{ cursor: "pointer" }}
              onClick={props.closeModal}
              src="/icons/close.svg"
              width={30}
              height={30}
            />
          </div>

          <div className={classes.heading}>Book a Meeting</div>

          <div className={classes.divider}></div>
        </div>
        <div className={classes.ModalContent}>
          <div className={classes.imageContainer}>
            <img
              className={classes.image}
              src={headshotUrl}
              alt={contactName}
              width="auto"
              height={220}
            />
          </div>
          <div className={classes.details}>
            <div className={classes.name}>{contactName}</div>
            <div className={classes.designation}>{title}</div>
            <div className={classes.des}>{modalDescription}</div>
          </div>
        </div>
        <div className={classes.calendly}>
          <InlineWidget styles={{ height: "900px" }} url={calendlyLink} />
        </div>
      </div>
    </Modal>
  )
}

export default SalesForceBookingModal
